var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section",
      staticStyle: { height: "auto", padding: "20px 20px 10px 20px" },
      attrs: { id: "oversea-agent" }
    },
    [
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: !_vm.isEdit,
                inline: true,
                "label-width": "132px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Partners.forecastReceivingEmail") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { no: "forcastAddress" },
                    model: {
                      value: _vm.form.forcastAddress,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "forcastAddress", $$v)
                      },
                      expression: "form.forcastAddress"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticStyle: { display: "flex" } }, [
        _c(
          "div",
          { staticClass: "section form-column" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  disabled: !_vm.isEdit,
                  inline: true,
                  "label-width": "132px",
                  "label-position": "left"
                }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Partners.oceanBillOfLadingAddress")))
                ]),
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c(
                    "div",
                    { staticClass: "section form-column" },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Consignee")))
                      ]),
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          { key: "blAddressLine" + count },
                          [
                            _c("el-input", {
                              ref: "blAddressLine" + count,
                              refInFor: true,
                              staticStyle: { width: "300px" },
                              attrs: {
                                no: "blAddressLine" + count,
                                "filter-chars": false
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "blAddressLine" + count,
                                    count + 1 > 7
                                      ? null
                                      : "blAddressLine" + (count + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showBlAddressDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form["blAddressLine" + count],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "blAddressLine" + count,
                                    $$v
                                  )
                                },
                                expression: "form['blAddressLine'+count]"
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "section form-column" },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NotifyParty")))
                      ]),
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          { key: "blNotifyAddressLine" + count },
                          [
                            _c("el-input", {
                              ref: "blNotifyAddressLine" + count,
                              refInFor: true,
                              staticStyle: { width: "300px" },
                              attrs: {
                                no: "blNotifyAddressLine" + count,
                                "filter-chars": false
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "blNotifyAddressLine" + count,
                                    count + 1 > 7
                                      ? null
                                      : "blNotifyAddressLine" + (count + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showBlNotifyAddressDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form["blNotifyAddressLine" + count],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "blNotifyAddressLine" + count,
                                    $$v
                                  )
                                },
                                expression: "form['blNotifyAddressLine'+count]"
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ])
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "section form-column" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  disabled: !_vm.isEdit,
                  inline: true,
                  "label-width": "132px",
                  "label-position": "left"
                }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Partners.airBillOfLadingAddress")))
                ]),
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c(
                    "div",
                    { staticClass: "section form-column" },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Consignee")))
                      ]),
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          { key: "airAddressLine" + count },
                          [
                            _c("el-input", {
                              ref: "airAddressLine" + count,
                              refInFor: true,
                              staticStyle: { width: "300px" },
                              attrs: {
                                no: "airAddressLine" + count,
                                "filter-chars": false
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "airAddressLine" + count,
                                    count + 1 > 7
                                      ? null
                                      : "airAddressLine" + (count + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showAirAddressDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form["airAddressLine" + count],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "airAddressLine" + count,
                                    $$v
                                  )
                                },
                                expression: "form['airAddressLine'+count]"
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "section form-column" },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NotifyParty")))
                      ]),
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          { key: "airNotifyAddressLine" + count },
                          [
                            _c("el-input", {
                              ref: "airNotifyAddressLine" + count,
                              refInFor: true,
                              staticStyle: { width: "300px" },
                              attrs: {
                                no: "airNotifyAddressLine" + count,
                                "filter-chars": false
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "airNotifyAddressLine" + count,
                                    count + 1 > 7
                                      ? null
                                      : "airNotifyAddressLine" + (count + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showAirNotifyAddressDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form["airNotifyAddressLine" + count],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "airNotifyAddressLine" + count,
                                    $$v
                                  )
                                },
                                expression: "form['airNotifyAddressLine'+count]"
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ])
              ]
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "box" }, [
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("Partners.theCorrespondingServiceOverseaAgent")))
        ]),
        _c(
          "div",
          { staticClass: "triggers", staticStyle: { "margin-bottom": "10px" } },
          [
            _c(
              "el-button",
              {
                attrs: { no: "new", disabled: !_vm.isEdit, type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.showEditDialog(true)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
            ),
            _c(
              "el-button",
              {
                attrs: { no: "edit", disabled: !_vm.isEdit, type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.showEditDialog(false)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
            ),
            _c(
              "el-button",
              {
                attrs: { no: "delete", disabled: !_vm.isEdit, type: "danger" },
                on: { click: _vm.remove }
              },
              [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "grid-wrapper", staticStyle: { "flex-grow": "1" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "100%" },
            attrs: {
              "grid-params": _vm.girdParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.girdParams = $event
              },
              "update:grid-params": function($event) {
                _vm.girdParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.businessType") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "lob" },
                          model: {
                            value: _vm.editDialog.form.lob,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "lob", $$v)
                            },
                            expression: "editDialog.form.lob"
                          }
                        },
                        _vm._l(_vm.lobSource, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Tool.User") } },
                    [
                      _c("cargo-user-select", {
                        staticStyle: { width: "190px" },
                        attrs: {
                          no: "overseaOp",
                          "method-params": {
                            category: "role",
                            shape: "overseaOp"
                          },
                          "default-value": _vm.editDialog.form.userId || ""
                        },
                        on: { change: _vm.selectCargoItem }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.isDefault") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "defaultUser" },
                          model: {
                            value: _vm.editDialog.form.defaultUser,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "defaultUser", $$v)
                            },
                            expression: "editDialog.form.defaultUser"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            { attrs: { no: "yes", label: true } },
                            [_vm._v(_vm._s(_vm.$t("Message.Yes")))]
                          ),
                          _c(
                            "el-radio",
                            { attrs: { no: "no", label: false } },
                            [_vm._v(_vm._s(_vm.$t("Message.No")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.remarks") } },
                    [
                      _c("el-input", {
                        attrs: { no: "remarks" },
                        model: {
                          value: _vm.editDialog.form.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "remarks", $$v)
                          },
                          expression: "editDialog.form.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.saveSub }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              disabled: _vm.readonly
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }